import ProgramCreateStep from "./ProgramCreateStep";

export default function ProgramCreateSteps({children}) {
    return (
        <div className={'program-create-steps'}>
            {children}
        </div>
    )
}